import React from "react";
import { Link } from "react-router-dom";
import chefimg from '../../assets/images/abt_sideKnife.png'
import chefimg01 from '../../assets/images/master_chef.jpeg'
import Img01 from '../../assets/images/chef_cap.png'
import Img02 from '../../assets/images/chef_text.png'

function Chef() {
  return (
    <>
      <section className="chef_section row_am bg_white_textcher">
        <div className="side_shape position-absolute">
          <img src={chefimg} alt="img" />
        </div>
        <div className="container">
          <div className="row my-2 my-sm-4">
            <div className="col-md-6" data-aos="fade-up" data-aos-duration={1500} >
              <div className="chef_img">
                <img className="radius_img img-fluid" src={chefimg01} alt="img" />
              </div>
              <h3 className="chef_name">
                <span>The Olive Tree</span>  Restaurant & Bar ️
              </h3>
            </div>
            <div className="col-md-6">
              <div className="abt_chef" data-aos="fade-up" data-aos-duration={1500} >
                <div className="banner_badge">
                  <img className="img-fluid" src={Img01} alt="img" />
                  <div className="round_anim">
                    <img src={Img02} alt="img" />
                  </div>
                </div>
                <div className="section_title">
                  <span className="sub_text">Our chef</span>
                  <h2 className="mb-3">
                  Restaurant & Bar with 30 <br /> years of experience
                  </h2>
                  <p>
                  Just a stone's throw from the world-famous Ölüdeniz Blue Lagoon, The Olive Tree Restaurant & Bar in Hisarönü offers a delicious escape for travelers exploring the wonders of Fethiye.  Established in 1994, our restaurant boasts a rich culinary heritage, using the freshest local ingredients and traditional cooking techniques to capture the essence of the Mediterranean.                  </p>
                </div>
              {/*   <Link to="#" className="btn btn_text">
                  meet our team <i className="icofont-long-arrow-right" />
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Chef;
